import * as React from "react";
import { Box, Chip, Paper, Typography } from "@mui/material";
import { FolderTreePicker } from "../../../../ViewFileList/ElementFunctions/MoveFile/FolderTreePicker";
import UserCreationContext from "./UserCreationContext";

// Scope stays the Hausverwaltung tree for now; widening it is a separate decision.
export const INVITE_FOLDER_ROOT = "Hausverwaltung/";

/** "Hausverwaltung/Haus 1/Wohnung 3/" -> "Haus 1 / Wohnung 3" */
export const folderLabelFromKey = (key: string, rootPrefix: string = INVITE_FOLDER_ROOT): string => {
  const relative = key.startsWith(rootPrefix) ? key.slice(rootPrefix.length) : key;
  return relative.split("/").filter((part) => part.length > 0).join(" / ");
};

export default function AddFoldersToUser() {
  const { accessibleFolders, setAccessibleFolders } = React.useContext(UserCreationContext);

  const toggleFolder = (key: string) => {
    if (key === INVITE_FOLDER_ROOT) {
      // Sharing the whole Hausverwaltung tree is not what an invite is for.
      return;
    }
    if (accessibleFolders.some((f) => f.key === key)) {
      setAccessibleFolders(accessibleFolders.filter((f) => f.key !== key));
    } else {
      setAccessibleFolders([...accessibleFolders, { key, label: folderLabelFromKey(key) }]);
    }
  };

  const removeFolder = (key: string) => {
    setAccessibleFolders(accessibleFolders.filter((f) => f.key !== key));
  };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "row" }}>
      <Paper elevation={3} sx={{ flex: 1, p: 1, maxHeight: "500px" }}>
        <Typography sx={{ textDecoration: "underline" }}>Zugriff auf folgende Ordner:</Typography>
        <Box sx={{ display: "flex", mt: 2, flexWrap: "wrap", maxHeight: "400px", overflowY: "auto" }}>
          {accessibleFolders.map((folder) => (
            <Chip
              key={folder.key}
              sx={{ m: 0.2 }}
              label={folder.label}
              onDelete={() => removeFolder(folder.key)}
            />
          ))}
          {accessibleFolders.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              Noch keine Ordner ausgewählt.
            </Typography>
          )}
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ flex: 1, ml: 2, p: 1, maxHeight: "500px" }}>
        <Typography sx={{ textDecoration: "underline", mb: 1 }}>Ordner auswählen:</Typography>
        <FolderTreePicker
          multiSelect
          allowedRootPrefix={INVITE_FOLDER_ROOT}
          selectedFolderIds={accessibleFolders.map((f) => f.key)}
          selectedFolderId={null}
          currentFileId=""
          onSelectFolder={(folderId) => toggleFolder(folderId)}
        />
      </Paper>
    </Box>
  );
}
